import {fetchJSONByGet, fetchJSONByPost} from './index.js'

export const getListApi = (params, trigger = false) => fetchJSONByGet('/adms_api_v0/order/repeat/purchase/page', params, {trigger})
export const exportApi = (params) => fetchJSONByPost('/adms_api_v0/order/repeat/purchase/excel', {}, {params, responseType: 'blob'})
